module.exports = __webpack_public_path__ + "img/yiliao6-2.db0caa83.jpg";